import script from "./AddArtwork.vue?vue&type=script&setup=true&lang=js"
export * from "./AddArtwork.vue?vue&type=script&setup=true&lang=js"

import "./AddArtwork.vue?vue&type=style&index=0&id=bd364702&lang=css"

const __exports__ = script;

export default __exports__